import React from 'react';

const Clients: React.FC = () => {
  // Our Clients - Actual client logos from astrixinfonet.com
  const clients = [
    {
      name: 'Client 1',
      logo: '/images/clients/client1.png',
    },
    {
      name: 'Client 2',
      logo: '/images/clients/client2.jpg',
    },
    {
      name: 'Client 3',
      logo: '/images/clients/client3.jpg',
    },
    {
      name: 'Client 4',
      logo: '/images/clients/client4.jpg',
    },
    {
      name: 'Client 5',
      logo: '/images/clients/client5.jpg',
    },
    {
      name: 'Client 6',
      logo: '/images/clients/client6.png',
    },
    {
      name: 'Client 7',
      logo: '/images/clients/client7.png',
    },
    {
      name: 'Client 8',
      logo: '/images/clients/client8.jpg',
    },
    {
      name: 'Client 9',
      logo: '/images/clients/client9.jpg',
    },
    {
      name: 'Client 10',
      logo: '/images/clients/client10.jpg',
    },
    {
      name: 'Client 11',
      logo: '/images/clients/client11.png',
    },
    {
      name: 'Client 12',
      logo: '/images/clients/client12.png',
    },
  ];

  return (
    <section id="clients" className="py-16 bg-gray-50">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-12">
          <span className="text-blue-600 font-semibold text-lg">Trusted By Industry Leaders</span>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mt-2 mb-4">
            Our Clients
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto text-lg">
            We are proud to serve some of the most respected organizations across various industries.
          </p>
        </div>

        {/* Clients Logo Carousel/Grid */}
        <div className="relative overflow-hidden">
          {/* Scrolling Animation Container */}
          <div className="flex animate-scroll">
            {/* First set of logos */}
            <div className="flex space-x-12 px-6">
              {clients.map((client, index) => (
                <div
                  key={`first-${index}`}
                  className="flex-shrink-0 bg-white rounded-xl p-6 w-48 h-24 flex items-center justify-center shadow-md hover:shadow-lg transition-shadow"
                >
                  <img
                    src={client.logo}
                    alt={client.name}
                    title={client.name}
                    className="max-h-16 max-w-full object-contain transition-all duration-300 hover:scale-110"
                  />
                </div>
              ))}
            </div>
            {/* Duplicate set for seamless loop */}
            <div className="flex space-x-12 px-6">
              {clients.map((client, index) => (
                <div
                  key={`second-${index}`}
                  className="flex-shrink-0 bg-white rounded-xl p-6 w-48 h-24 flex items-center justify-center shadow-md hover:shadow-lg transition-shadow"
                >
                  <img
                    src={client.logo}
                    alt={client.name}
                    title={client.name}
                    className="max-h-16 max-w-full object-contain transition-all duration-300 hover:scale-110"
                  />
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Stats */}
        <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
          <div className="bg-white rounded-xl p-6 shadow-md">
            <h3 className="text-4xl font-bold text-blue-600 mb-2">500+</h3>
            <p className="text-gray-600">Happy Clients</p>
          </div>
          <div className="bg-white rounded-xl p-6 shadow-md">
            <h3 className="text-4xl font-bold text-blue-600 mb-2">50+</h3>
            <p className="text-gray-600">Enterprise Clients</p>
          </div>
          <div className="bg-white rounded-xl p-6 shadow-md">
            <h3 className="text-4xl font-bold text-blue-600 mb-2">10+</h3>
            <p className="text-gray-600">Industries Served</p>
          </div>
          <div className="bg-white rounded-xl p-6 shadow-md">
            <h3 className="text-4xl font-bold text-blue-600 mb-2">98%</h3>
            <p className="text-gray-600">Client Retention</p>
          </div>
        </div>
      </div>

      {/* CSS for scrolling animation */}
      <style>{`
        @keyframes scroll {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }
        .animate-scroll {
          animation: scroll 30s linear infinite;
        }
        .animate-scroll:hover {
          animation-play-state: paused;
        }
      `}</style>
    </section>
  );
};

export default Clients;
